import { IconButton, Tooltip } from '@material-tailwind/react'
import { PiFootprintsFill, PiSidebarSimpleBold } from 'react-icons/pi'
import { MdOutlineFitScreen } from 'react-icons/md'
import { useTranslation } from 'react-i18next'
import VolumeButton from './VolumeButton'
import { useMapControls } from '../contexts/MapControlsContext'
import { useXp } from '../contexts/XpContext'
import { useDevice } from '../hooks/device'
import { basicControlStyle, activeControlStyle, inactiveControlStyle } from '../style/tailwindClasses'

const Controls: React.FC = () => {
  const { t } = useTranslation()
  const { fitMapBounds, setDrawer, drawerForced } = useMapControls()
  const { manualMode, setManualMode, volume, setVolume, mute, setMute } = useXp()

  const device = useDevice()
  const isMobile = device?.platformType === 'mobile'

  return (
    <div className="absolute top-3 left-1 p-3 z-[33]">
      <div className="flex flex-col gap-y-2 md:gap-y-3 align-middle">
        {!drawerForced && (
          <Tooltip
            content={t('controls.openExperiencesList')}
            placement="left"
            {...(isMobile && { open: false })}
          >
            <IconButton
              size="md"
              color="white"
              className={`${basicControlStyle}`}
              onClick={() => setDrawer(!drawerForced)}
              data-testid="control-drawer-toggle"
            >
              <PiSidebarSimpleBold className="h-4 w-4 md:h-5 md:w-5" />
            </IconButton>
          </Tooltip>
        )}

        <Tooltip
          content={manualMode ? t('controls.useRealGeolocation') : t('controls.simulatePosition')}
          placement="left"
          {...(isMobile && { open: false })}
        >
          <IconButton
            size="md"
            color="white"
            className={`${basicControlStyle} ${manualMode ? activeControlStyle : inactiveControlStyle}`}
            onClick={() => setManualMode(!manualMode)}
            data-testid="control-simulate-location"
          >
            <PiFootprintsFill className="h-4 w-4 md:h-5 md:w-5" />
          </IconButton>
        </Tooltip>

        <Tooltip content={t('controls.fitBounds')} placement="left" {...(isMobile && { open: false })}>
          <IconButton
            size="md"
            color="white"
            className={basicControlStyle}
            onClick={() => fitMapBounds()}
            data-testid="control-fit-bounds"
          >
            <MdOutlineFitScreen className="h-4 w-4 md:h-5 md:w-5" />
          </IconButton>
        </Tooltip>

        <Tooltip
          content={mute ? t('controls.unmute') : t('controls.mute')}
          placement="left"
          {...(isMobile && { open: false })}
        >
          <IconButton
            size="md"
            color="white"
            className={`${basicControlStyle} ${mute ? activeControlStyle : inactiveControlStyle}`}
            onClick={() => setMute(!mute)}
            data-testid="control-mute-toggle"
          >
            <VolumeButton mute={mute} volume={volume} />
          </IconButton>
        </Tooltip>

        <Tooltip content={t('controls.setVolume')} placement="left" {...(isMobile && { open: false })}>
          <div className="text-center">
            <input
              type="range"
              className="accent-primary dark:accent-base-gray-500 cursor-pointer"
              style={
                {
                  MozOrient: 'vertical',
                  '-webkit-appearance': 'slider-vertical',
                  writingMode: 'vertical-rl',
                  transform: 'scale(1, -1)',
                } as React.CSSProperties
              }
              onChange={(e) => {
                setVolume(e.target.valueAsNumber)
              }}
              value={volume}
              max={1}
              min={0}
              step={0.01}
              data-testid="control-volume-slider"
            />
          </div>
        </Tooltip>
      </div>
    </div>
  )
}

export default Controls
